import argv from 'minimist-argv';
import detectBoard from './utils/detectBoard';
import parseHostPort from './utils/parseHostPort';

export const board = detectBoard();

export const serverAddress =
  process.env.SERVER_ADDRESS ||
  argv.address ||
  `${process.env.SERVER_HOST || argv.host}:${process.env.SERVER_PORT || argv.port}`;
const [serverHost, serverPort] = parseHostPort(serverAddress);

export { serverHost, serverPort };

export const webPort = process.env.WEB_PORT || argv['web-port'] || 80;
export const token = process.env.TOKEN || argv.token || process.env.USER_ID || argv.userId;

const guessUser = () => {
  if (!board.user) throw new Error('Please provide USER');
  return board.user;
};

export const user =
  (process.env.USER !== 'root' && process.env.USER) ||
  process.env.PI_USER ||
  argv.piUser ||
  guessUser();

if (!serverAddress || serverAddress === ':') {
  // eslint-disable-next-line no-console
  console.log('WARNING: address is missing');
}

if (!token) {
  // eslint-disable-next-line no-console
  console.log('WARNING: userId is missing');
}
